export default __webpack_public_path__ + "static/media/DOGE.a5985066.svg";